import { render, staticRenderFns } from "./ModifierKeyStateWarning.vue?vue&type=template&id=64f46ba5&"
import script from "./ModifierKeyStateWarning.vue?vue&type=script&lang=js&"
export * from "./ModifierKeyStateWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports